import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import styled from "styled-components"

import WithCollection from "areas/collection/hoc/with-collection"
import LooksSelector from "areas/collection/looks-selector"
import { setProductsClickedOnHistory } from "helpers/collection"

import ProductImage from "./product-image"
import ProductPrice from "./product-price"
import WishlistIcon from "./wishlist-icon"

const GridItem = styled.div`
  margin-bottom: 24px;
  padding: 0 5px;
  position: relative;
  text-align: center;
  ${({ theme }) => theme.mediaQueries.tablet`
    width: 33.333%;
    margin-bottom: 30px;
  `};
  width: ${(props) => (props.gridView === "small" ? "50%" : "100%")};
`

const Badge = styled(Typography).attrs((props) => ({
  as: "span",
  color: "black",
  ...props,
}))`
  align-items: center;
  border-radius: 10px;
  display: inline-flex;
  justify-content: center;
  font-size: 11px;
  font-weight: 300;
  padding: 2px 8px;
  position: absolute;
  right: 20px;
  top: 5px;
  z-index: 1;
`
const LooksSelectorWrapper = styled(Box).attrs((props) => ({
  height: "33px",
  ...props.theme.collectionLooksWrapper,
}))``

const InternalCollectionProduct = ({
  confirmWishlist,
  detectScrollPageProduct,
  gridView,
  index,
  product,
  setProductParams,
  linkClickData,
}) => {
  const [selectedLook, setSelectedLook] = useState(setDefaultLook(product))
  const [firstImageLoaded, setFirstImageLoaded] = useState(true)
  const ref = useRef()

  useEffect(() => {
    // Update selected metal when default_look is changed
    setSelectedLook(setDefaultLook(product))
    if (product.pageHref) {
      const checkScrollPosition = detectScrollPageProduct(product, ref)
      const checkScrollTick = () => {
        window.requestAnimationFrame(checkScrollPosition)
      }
      window.addEventListener("scroll", checkScrollTick)
      return () => {
        window.removeEventListener("scroll", checkScrollTick)
      }
    }
  }, [product])

  const setClickedOnHistory = () => {
    setProductsClickedOnHistory(product.rm_style_code || product.style_code, {
      cidx: index + 1,
      cpg: product.pageIndex || 1,
      csc: product.style_code,
    })
  }

  const selectedProductLook = product.looks[selectedLook]

  if (!selectedProductLook) {
    // Prevents selectedLook from being undefined and breaking the component on reload of products. Gives useEffect a chance to update.
    return null
  }
  const badge = product.badges[0]

  return (
    <GridItem gridView={gridView} ref={ref}>
      <WishlistIcon
        {...{
          confirmWishlist,
          product,
          selectedProductLook,
          setProductParams,
        }}
      />
      {badge && (
        <Badge bg={badge.color} color={badge.label_color} {...badge.style}>
          {badge.label}
        </Badge>
      )}
      <Link
        data-cy={`collection-product-link-${product.style_code}`}
        data-lc={linkClickData}
        onClick={setClickedOnHistory}
        to={selectedProductLook.product_url}
      >
        <ProductImage
          alt={product.name}
          firstImageLoaded={firstImageLoaded}
          images={selectedProductLook.images}
          index={index}
          setFirstImageLoaded={(value) => setFirstImageLoaded(value)}
          styleCode={product.style_code}
          type={product.product_type}
        />
      </Link>
      <LooksSelectorWrapper>
        {Object.keys(product.looks).length > 1 && (
          <LooksSelector
            looks={product.looks}
            product={product}
            selectedLook={selectedLook}
            updateLook={(look) => setSelectedLook(look)}
          />
        )}
      </LooksSelectorWrapper>
      <Link data-lc={linkClickData} to={selectedProductLook.product_url}>
        {/* {sl.config.show_availability_in_collection &&
          product.isAvailForChristmas && (
            <Typography color="#197603" fontSize={11} my="4px">
              <FontAwesomeIcon
                icon={faGift}
                style={{ verticalAlign: "text-top" }}
              />{" "}
              Christmas Delivery
            </Typography>
          )} */}
        <ProductPrice
          product={{
            ...selectedProductLook,

            style_code: product.style_code,
          }}
        />
        {product.hasDiamond && (
          <Typography as="span" fontSize={12} italic>
            {product.hasDiamond}
          </Typography>
        )}
      </Link>
    </GridItem>
  )
}

InternalCollectionProduct.propTypes = {
  confirmWishlist: PropTypes.func,
  detectScrollPageProduct: PropTypes.func,
  gridView: PropTypes.string,
  index: PropTypes.number,
  linkClickData: PropTypes.string,
  product: PropTypes.object,
  setProductParams: PropTypes.func,
}

const setDefaultLook = (product) => {
  return product.looks && product.looks[product.default_look]
    ? product.default_look
    : Object.keys(product.looks)[0]
}

const mapStateToProps = () => ({})

const mapDispatchToProps = () => ({})

const CollectionProduct = connect(
  mapStateToProps,
  mapDispatchToProps
)(WithCollection(InternalCollectionProduct))

export default CollectionProduct
